// 统计点击次数
import request from "@/utils/request";

export function countNum(data) {
    return request({
        url: process.env.VUE_APP_BASE_API+'/oa/num/add',
        method: 'post',
        data
    })
}